import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalenderTomorrow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calender-tomorrow"} maskId="square-filled-radius-0-stroke-1-IconCalenderTomorrow"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM20 8.25H4V20H20V8.25ZM10.75 10.7929L13.9571 14L10.75 17.2071L10.0429 16.5L12.5429 14L10.0429 11.5L10.75 10.7929Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalenderTomorrow;
